import React, { useContext, useEffect } from 'react'
import { setTitlePage } from '../../Services/Config/ConfigService';
import { getLabel } from '../../Services/Language/LanguageService';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

const HomeScreenBase = ({ HomeScreen }) => {

  const {config} = useContext(ConfigContext);

  useEffect(() => {
    setTitlePage(getLabel(baseLang, 'Home', config.Language));
}, [])


  return (
    <div className='homeScreen' style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      {HomeScreen && <HomeScreen />}
    </div>
  )
}

export default HomeScreenBase